import { format } from "date-fns";

import { fromLocationDTO } from "./location"
import { fromWorkDaysDTO, toWorkDaysDTO } from "./workDay"

export const fromUserDTO = (user) => {
    return {
        id: user.id,
        name: user.name,
        institute: user.institute,
        locationId: user.locationId ? user.locationId : null,
        location: user.location ? fromLocationDTO(user.location) : null,
        isAllowedFlexTimeAccount: user.isAllowedFlexTimeAccount,
        hasFlexTimeAccount: user.hasFlexTimeAccount ?? null,
        startOfFlexTimeAccount: user.startOfFlexTimeAccount ? new Date(user.startOfFlexTimeAccount) : null,
        initialFlexTimeAccountBalance: !isNaN(user.initialFlexTimeAccountBalance) ? user.initialFlexTimeAccountBalance : null,
        contractInfo: user.contractInfo ? user.contractInfo : null,
        roles: user.roles ? user.roles : null,
        workDays: user.workDays ? fromWorkDaysDTO(user.workDays) : null
    }
}

export const fromUsersDTO = (users) => users.map(user => fromUserDTO(user))

export const toUserDTO = (user) => {
    return {
        id: user.id ? user.id : null,
        name: user.name ? user.name : null,
        institute: user.institute ? user.institute : null,
        locationId: user.locationId ? user.locationId : user.location ? user.location.id : null,
        isAllowedFlexTimeAccount: user.isAllowedFlexTimeAccount,
        hasFlexTimeAccount: user.hasFlexTimeAccount,
        startOfFlexTimeAccount: user.startOfFlexTimeAccount ? format(user.startOfFlexTimeAccount, "yyyy-MM-dd") : null,
        initialFlexTimeAccountBalance: !isNaN(user.initialFlexTimeAccountBalance)? user.initialFlexTimeAccountBalance : null,
        contractInfo: user.contractInfo ? user.contractInfo : null,
        roleIds: user.roleIds ? user.roleIds : user.roles ? user.roles.map(r => r.id) : null,
        workDays: user.workDays ? toWorkDaysDTO(user.workDays) : null
    }
}
